import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { trackEvent } from 'helpers/Analytics';
import { isCreativeJob } from 'helpers/HelperFunctions';
import Panel from 'components/Panel/Panel';
import styles from './PinderLikedUserCard.module.scss';
import UserCard2 from 'components/Shared/UserCard2/UserCard2';
import { Button, Clearfix, ListGroup, ListGroupItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import Icon from 'components/Icon/Icon';
import Price from 'components/Price/Price';
import TimeAgo from 'components/TimeAgo/TimeAgo';
import Modal from 'components/Modal/Modal';
import PaymentModal from 'components/Pitch/PaymentModal';
import PropTypes from 'prop-types';

const PinderLikedUserCard = ({
  pitch,
  pitchListProps,
  userCardRef,
  user,
  preferredRole,
}) => {
  const [showAcceptPitch, setShowAcceptPitch] = useState(false);

  const { brief, onAccepted, ...rest } = pitchListProps;

  const showPaymentProcessor = () => {
    setShowAcceptPitch(true);
  };

  const onAccept = (totalToPay) => {
    onAccepted(pitch, totalToPay * 100);
    setShowAcceptPitch(false);
  };

  const isCreativeUser = () => {
    const [firstRole] = pitch.sender ? pitch.sender.top_roles : [''];
    if (firstRole && isCreativeJob(firstRole)) {
      return true;
    }
    return false;
  };

  return (
    <Fragment>
      <Panel
        className={styles.gridContainer}
        key={`PinderLikedUserCard-panel-${pitch.id}`}
      >
        <UserCard2
          pitch={pitch}
          user={pitch && pitch.sender}
          ref={userCardRef}
          customStylesheet={styles}
          preferredRole={preferredRole}
        />
        <div
          className={`${styles.HiringInfoContainer} ${
            isCreativeUser() ? styles.creativeUser : ''
          }`}
        >
          {pitch.day_rate && (
            <div
              className={styles.dayRateMobile}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              <span>
                Standard rate:{' '}
                <Price
                  currency={pitch.day_rate_currency}
                  amount={pitch.day_rate}
                  rounded
                />{' '}
                /day
              </span>
            </div>
          )}
          {pitch.amount > 0 && (
            <div className={styles.feeInfo}>
              {pitch?.commission && (
                <>
                  <div className={`${styles.pitchFee} ${styles.feeLine}`}>
                    <span>{`${pitch?.sender?.displayname}'s fee`}:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.jobFee}
                    />
                  </div>
                  <div className={`${styles.serviceCharge} ${styles.feeLine}`}>
                    <span>Service charge:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.twineFee}
                    />
                  </div>
                  <div className={`${styles.processingFee} ${styles.feeLine}`}>
                    <span>Card processing:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.cardFee}
                    />
                  </div>
                  <hr className={styles.hrBlock} />
                  <div className={`${styles.total} ${styles.feeLine}`}>
                    <span>Total:</span>
                    <Price
                      currency={brief?.currency}
                      amount={pitch?.commission?.totalPayment}
                    />
                  </div>
                </>
              )}
            </div>
          )}
          {pitch.accepted_at === '' && pitch.declined_at === '' && (
            <>
              <LinkContainer
                to={'/messages/' + pitch.sender.username}
                className={styles.messageButtonMobile}
              >
                <Button
                  bsStyle="info"
                  onClick={() => {
                    trackEvent('pitch-discuss-project', {
                      brief: brief.id,
                      pitch: pitch.id,
                    });
                  }}
                >
                  Reply to pitch{' '}
                  <SvgIcon className={styles.icon} size="14px" icon="bubble" />
                </Button>
              </LinkContainer>
              <Button
                className={styles.hireButtonMobile}
                bsStyle="success"
                onClick={() => {
                  showPaymentProcessor();
                }}
              >
                Hire <Icon className={styles.icon} icon="&#xe60c;" />
              </Button>
            </>
          )}
          <div className={styles.hiringInfo}>
            {pitch?.timestamp && (
              <div className={styles.pitchAge}>
                Submitted <TimeAgo timestamp={pitch.timestamp} />
              </div>
            )}
            {pitch.day_rate && (
              <div
                className={styles.dayRate}
                style={{ whiteSpace: 'pre-wrap' }}
              >
                <span>
                  Standard rate:{' '}
                  <Price
                    currency={pitch.day_rate_currency}
                    amount={pitch.day_rate}
                    rounded
                  />{' '}
                  /day
                </span>
              </div>
            )}
            {pitch.accepted_at === '' && pitch.declined_at === '' && (
              <>
                <LinkContainer
                  to={'/messages/' + pitch.sender.username}
                  className={styles.messageButton}
                >
                  <Button
                    bsStyle="info"
                    onClick={() => {
                      trackEvent('pitch-discuss-project', {
                        brief: brief.id,
                        pitch: pitch.id,
                      });
                    }}
                  >
                    Reply to pitch{' '}
                    <SvgIcon
                      className={styles.icon}
                      size="14px"
                      icon="bubble"
                    />
                  </Button>
                </LinkContainer>
                <Button
                  className={styles.hireButton}
                  bsStyle="success"
                  onClick={() => {
                    showPaymentProcessor();
                  }}
                >
                  Hire <Icon className={styles.icon} icon="&#xe60c;" />
                </Button>
              </>
            )}
          </div>
        </div>
      </Panel>
      <Modal
        closeButton
        show={showAcceptPitch}
        title={`Hire ${pitch?.sender?.displayname}`}
        onExit={() => setShowAcceptPitch(false)}
      >
        <PaymentModal
          brief={brief}
          pitch={pitch}
          onAccept={(totalToPay) => onAccept(totalToPay)}
          clientid={user?.id}
          clientemail={user?.email}
        />
      </Modal>
    </Fragment>
  );
};

PinderLikedUserCard.propTypes = {
  pitch: PropTypes.object,
  pitchListProps: PropTypes.object,
  user: PropTypes.object,
  preferredRole: PropTypes.string,
};

export default connect(({ auth: { user } }) => ({ user }))(PinderLikedUserCard);
